import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import { getUrlParam } from '@tencent/vft-common/util';
import { cookie, Boss } from '@tencent/vft-common';
import { getPlatform } from './util';
import createLogger from './logger';
/**
 * 预置上报参数
 * @type {VftReport.ReportParams}
 */

export var PRESET_PARAMS = {
  /** url链接 */
  f_url: location.pathname,

  /** 域名（H5上报） */
  f_dm: location.host,

  /** 域名协议 */
  f_protocol: location.protocol,

  /** url参数，如果含有$，需要用|||替换，再上报 */
  f_url_param: (decodeURIComponent(location.href).split('?')[1] || '').replace(/\$/g, '|||'),

  /** ptag，优先取url中ptag参数，如果没有则取aid的13级； */
  f_pagetag: getUrlParam('ptag', location.href) || (sessionStorage ? sessionStorage.getItem('ptag') : null) || cookie.get('ptag'),
  f_pt: getPlatform()
};
/**
 * 创建上报器
 * @param {VftReport.ConstructOptions} options 上报配置
 *
 * @return {VftReport.ReporterInstance}
 */

export function createReporter(_ref) {
  var config = _ref.config,
      _ref$extraParams = _ref.extraParams,
      extraParams = _ref$extraParams === void 0 ? null : _ref$extraParams,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? false : _ref$delay,
      _ref$silent = _ref.silent,
      silent = _ref$silent === void 0 ? true : _ref$silent;

  if (!config) {
    console.error('[reporter] config is required');
    return null;
  }

  if (!config.bossId || !config.pwd) {
    console.error('[reporter] config.bossId and config.pwd is required');
    return null;
  }

  var logger = createLogger(silent);
  var boss = new Boss(config);
  /**
   * @type {VftReport.ReporterInstance}
   */

  var reporter = {
    /**
     * @private
     */
    $boss: boss,

    /**
     * @private
     * 上报队列
     */
    $queue: [],

    /**
     * @private
     * 上报参数
     */
    $presetParams: {},

    /**
     * @private
     * 额外上报参数
     */
    $extraParams: {},

    /**
     * 上报是否已初始化
     */
    isReady: false,

    /**
     * 上报初始化
     */
    init: function init() {
      this.$presetParams = Object.assign({}, PRESET_PARAMS);
      logger('init', this.$presetParams);
    },

    /**
     * 设置额外上报参数
     */
    setExtraParams: function setExtraParams() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isFunction = typeof extraParams === 'function';

      try {
        this.$extraParams = Object.assign({}, (extraParams && isFunction ? extraParams(this.$presetParams) : {}) || {}, params || {});
      } catch (error) {
        console.error('[reporter](setExtraParams)', error);
      }
    },

    /**
     * 重新初始化
     */
    reinit: function reinit() {
      this.setExtraParams();
      logger('reinit', this.$extraParams);
    },

    /**
     * 上报就绪
     */
    ready: function ready() {
      if (this.isReady) {
        return;
      }

      this.setExtraParams();
      logger('ready', this.$extraParams);
      this.isReady = true;

      while (this.$queue.length) {
        var params = this.$queue.pop();
        this.report(params);
      }
    },

    /**
     * 上报
     * @param params 上报参数
     * @param type 上报类型
     */
    report: function report(params) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'expose';
      params = Object.assign({
        _dc: Math.random()
      }, this.$presetParams, this.$extraParams, params, {
        f_event: type
      });

      if (!this.isReady) {
        this.$queue.push(params);
        return;
      }

      logger(type, params);
      this.$boss.report(params);
    },

    /**
     * 曝光上报
     * @param params 上报参数
     */
    expose: function expose(params) {
      this.report(params, 'expose');
    },

    /**
     * 点击上报
     * @param params 上报参数
     */
    click: function click(params) {
      this.report(params, 'click');
    }
  };
  reporter.init();

  if (!delay) {
    reporter.ready();
  }

  return reporter;
}